export enum PredefinedSnapshotType {
    
    UNDEFINED = 0,

    /// <summary>
    /// Only a person who created snapshot can see it.
    /// </summary>
    PERSONAL = 1,

    /// <summary>
    /// Everyone in team (other interviewers and recruiters) can see the snapshots
    /// </summary>
    TEAM = 2,

    /// <summary>
    /// Every Meet participant (TEAM + candidate) can see the snapshots
    /// </summary>
    ALL_PARTICIPANTS = 10,

}